import { Integration } from 'signup-constants/Integration';
import { isIntegrationValid } from 'signup-ui-lego-core/utils/isIntegrationValid';
import { getIntegrationKey } from '../routing/getIntegrationKey';
import { Step } from '../views/Step';
const CustomIntegrationsFlow = {
  [Integration.Wordpress]: () => ({
    preVerification: [Step.LandingPage, Step.CompanyName, Step.CompanyDomain, Step.CompanySize, Step.Industry, Step.JobRole, Step.CrmExperienceLevel, Step.CodeVerification],
    postVerification: [Step.Password, Step.HubletSelection],
    postAccountCreation: [Step.WordpressAuthorization],
    postExistingAccountSelection: [Step.WordpressAuthorization]
  }),
  [Integration.DesignKitGenerator]: () => ({
    preVerification: [Step.LandingPage, Step.CompanyName, Step.CompanyDomain, Step.CodeVerification],
    postVerification: [Step.Password, Step.HubletSelection],
    postAccountCreation: [],
    postExistingAccountSelection: []
  }),
  [Integration.Wpforms]: () => ({
    preVerification: [Step.LandingPage, Step.CompanyName, Step.CompanyDomain, Step.CodeVerification],
    postVerification: [Step.Password, Step.HubletSelection],
    postAccountCreation: [],
    postExistingAccountSelection: []
  }),
  [Integration.Shopify]: () => ({
    preVerification: [Step.LandingPage, Step.JobRole, Step.CompanyName, Step.CompanySize, Step.CompanyDomain, Step.CodeVerification],
    postVerification: [Step.Password, Step.HubletSelection],
    postAccountCreation: [Step.CrmExperienceLevel, Step.JobField],
    postExistingAccountSelection: []
  }),
  [Integration.Typeform]: () => ({
    preVerification: [Step.LandingPage, Step.CompanyName, Step.CompanyDomain, Step.CodeVerification],
    postVerification: [Step.Password, Step.HubletSelection],
    postAccountCreation: [],
    postExistingAccountSelection: []
  })
};
const DEFAULT_INTEGRATION_FLOW_STEPS = {
  preVerification: [Step.LandingPage, Step.JobRole, Step.CompanyName, Step.CompanySize, Step.CompanyDomain, Step.CodeVerification],
  postVerification: [Step.Password, Step.HubletSelection],
  postAccountCreation: [Step.CrmExperienceLevel, Step.JobField, Step.IntegrationsAccountCreated],
  postExistingAccountSelection: [Step.IntegrationsAccountCreated]
};
const FlowStepsByIntegration = Object.assign({}, CustomIntegrationsFlow);
export const getIntegrationFlowSteps = () => {
  const integrationKey = getIntegrationKey();

  if (!integrationKey || !isIntegrationValid(integrationKey)) {
    return DEFAULT_INTEGRATION_FLOW_STEPS;
  }

  const getFlowSteps = FlowStepsByIntegration[integrationKey];
  const flowSteps = getFlowSteps();
  return flowSteps;
};